import { all, takeEvery } from 'redux-saga/effects';
import {
    FETCH_LEADERBOARD_DATA,
    UPDATE_NAV_ITEM,
    UPDATE_BETTING_ODDS,
    FETCH_BETTING_ODDS_DATA,
    UPDATE_LEADERBOARD_FILTER,
    UPDATE_FAVOURITE_PLAYER
} from '../actions';
import { fetchLeaderboardData } from './fetch-leaderboard-data';
import { fetchBettingOddsData } from './fetch-betting-odds-data';
import { updateNavItem } from './update-nav-item';
import { updateBettingOdds } from './update-betting-odds';
import { updateLeaderboardFilter } from './update-leaderboard-filter';
import { updateFavouritePlayer } from './update-favourite-player';

/**
 *
 */
export function* leaderboardRootSaga() {
    yield all([
        takeEvery(UPDATE_FAVOURITE_PLAYER.REQUEST, updateFavouritePlayer),
        takeEvery(FETCH_LEADERBOARD_DATA.REQUEST, fetchLeaderboardData),
        takeEvery(FETCH_BETTING_ODDS_DATA.REQUEST, fetchBettingOddsData),
        takeEvery(UPDATE_NAV_ITEM.REQUEST, updateNavItem),
        takeEvery(UPDATE_BETTING_ODDS.REQUEST, updateBettingOdds),
        takeEvery(UPDATE_LEADERBOARD_FILTER.REQUEST, updateLeaderboardFilter)
    ]);
}
